<template>
	<div class="section">
		<div class="has-text-centered is-title-section">
			<p class="is-subtitle">RAZONES PARA ELEGIRNOS</p>
			<p class="is-title mt-3">Ofrecemos soluciones eficaces para tu adaptación digital</p>
		</div>

		<div class="container is-flex is-flex-wrap-wrap is-justify-content-center">
			<div class="box">
				<figure class="image is-inline-block">
					<img src="@/assets/img/services-1.png" />
				</figure>
				<p class="is-box-title mt-2">Diseño de Arquitectura de Software</p>
				<p class="is-box-text mt-3">Creamos arquitecturas escalables y seguras para que tus aplicaciones sean robustas y eficientes.</p>
			</div>
			<div class="box">
				<figure class="image is-inline-block">
					<img src="@/assets/img/services-2.png" />
				</figure>
				<p class="is-box-title mt-2">Automatización de procesos</p>
				<p class="is-box-text mt-3">Optimizamos tus procesos clave para reducir tiempos y costos operativos.</p>
			</div>
			<div class="box">
				<figure class="image is-inline-block">
					<img src="@/assets/img/services-3.png" />
				</figure>
				<p class="is-box-title mt-2">Actualización de sistemas</p>
				<p class="is-box-text mt-3">Mantenemos tus sistemas siempre actualizados y seguros, evitando vulnerabilidades.</p>
			</div>
			<div class="box">
				<figure class="image is-inline-block">
					<img src="@/assets/img/services-4.png" />
				</figure>
				<p class="is-box-title mt-2">Bases de datos y migraciones</p>
				<p class="is-box-text mt-3">Diseño, optimización y migración de bases de datos para un acceso rápido y confiable a tu información.</p>
			</div>
		</div>

		<div class="container is-flex is-flex-wrap-wrap is-justify-content-center">
			<div class="box">
				<figure class="image is-inline-block">
					<img src="@/assets/img/services-5.png" />
				</figure>
				<p class="is-box-title mt-2">Integración con servicios externos</p>
				<p class="is-box-text mt-3">Conectamos tu software con WhatsApp, CRM, ERP, APIs y más para impulsar tu negocio.</p>
			</div>
			<div class="box">
				<figure class="image is-inline-block">
					<img src="@/assets/img/services-6.png" />
				</figure>
				<p class="is-box-title mt-2">Infraestructura en la nube</p>
				<p class="is-box-text mt-3">Implementamos soluciones en AWS, Google Cloud y Azure para escalar tu operación.</p>
			</div>
			<div class="box">
				<figure class="image is-inline-block">
					<img src="@/assets/img/services-7.png" />
				</figure>
				<p class="is-box-title mt-2">Seguridad avanzada</p>
				<p class="is-box-text mt-3">Protegemos tus sistemas con SSO, OAuth 2.0 y Keycloak para garantizar acceso seguro.</p>
			</div>
			<div class="box">
				<figure class="image is-inline-block">
					<img src="@/assets/img/services-8.png" />
				</figure>
				<p class="is-box-title mt-2">IA para procesos</p>
				<p class="is-box-text mt-3">Aplicamos IA para automatizar y mejorar tareas, logrando eficiencia y calidad.</p>
			</div>
		</div>

		<div class="container is-flex is-flex-wrap-wrap is-justify-content-center mt-5">
			<div class="box">
				<figure class="image is-inline-block">
					<img src="@/assets/img/services-1.png" />
				</figure>
				<p class="is-box-title mt-2">Desarrollo integral</p>
				<p class="is-box-text mt-3">Desde el análisis hasta la implementación, creamos soluciones a la medida y gestionamos todo el ciclo.</p>
			</div>
			<div class="box">
				<figure class="image is-inline-block">
					<img src="@/assets/img/services-2.png" />
				</figure>
				<p class="is-box-title mt-2">BI y LLM</p>
				<p class="is-box-text mt-3">Analizamos datos y usamos modelos de lenguaje para optimizar decisiones y procesos en tiempo real.</p>
			</div>
			<div class="box">
				<figure class="image is-inline-block">
					<img src="@/assets/img/services-3.png" />
				</figure>
				<p class="is-box-title mt-2">Consultoría tecnológica</p>
				<p class="is-box-text mt-3">Diseñamos estrategias tecnológicas alineadas a tu negocio para crecer de forma inteligente.</p>
			</div>
			<div class="box">
				<figure class="image is-inline-block">
					<img src="@/assets/img/services-4.png" />
				</figure>
				<p class="is-box-title mt-2">IA conversacional</p>
				<p class="is-box-text mt-3">Creamos asistentes virtuales que entienden y responden de manera natural a tus clientes.</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ServicesMain',
};
</script>

<style scoped>
.section {
	background: var(--Dark-gradient, linear-gradient(9deg, #2c2c31 0%, #18181a 86.48%));
    padding-bottom: 150px;
}

.is-title-section {
	margin-top: 35px;
	margin-bottom: 55px;
}

.is-subtitle {
	color: var(--Blue, #2489ca);
	font-size: 18px;
	font-weight: 600;
	line-height: normal;
	letter-spacing: 5.4px;
}

.is-title {
	font-size: 26px;
	font-weight: 600;
	line-height: normal;
}

.box {
	margin: 20px;
    padding: 20px 30px;
	width: 235px;
	height: 290px;
	border-radius: 8px;
	background: #121214;
	box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.5);
}

.box:hover {
	border: 1px solid var(--Light-Blue, #15d9fd);
}

.image {
	width: 60px;
	margin: 20px 0px;
}

.is-box-title {
	color: var(--Light-Gray, #edeeed);
	font-size: 16px;
	font-style: normal;
	font-weight: 600;
	line-height: normal;
}

.is-box-text {
	color: var(--Light-Gray, #edeeed);
	text-align: justify;
	font-size: 10px;
	font-style: normal;
	font-weight: 600;
	line-height: 180%; /* 18px */
}

@media only screen and (max-width: 768px) {
    .section {
        padding: 3rem 0px;
        padding-bottom: 150px;
    }

    .is-title-section {
        margin: 40px 20px;
    }

    .is-subtitle {
        font-size: 12px;
        letter-spacing: 3.6px;
    }

    .is-title {
        font-size: 18px;
        line-height: normal;
    }

    .box {
        margin: 8px;
        padding: 15px 25px;
        width: 163px;
        height: 246px;
        border-radius: 6px;
    }

    .image {
        width: 43px;
        margin: 14px 0px;
    }

    .is-box-title {
        font-size: 12px;
    }

    .is-box-text {
        font-size: 9px;
        line-height: normal;
    }
}
</style>
